import newRequestTypes from "./newRequest.types";
export const setNewRequestType = (data) => ({
  type: newRequestTypes.SET_REQUEST_TYPE,
  payload: data,
});
export const setNewRequestSourceLocation = (data) => ({
  type: newRequestTypes.SET_SOURCE_LOCATION,
  payload: data,
});
export const setNewRequestDestinationLocation = (data) => ({
  type: newRequestTypes.SET_DESTINATION_LOCATION,
  payload: data,
});
export const setNewRequestOtherDestinationsLocation = (data) => ({
  type: newRequestTypes.SET_OTHER_DESTINATIONS_LOCATION,
  payload: data,
});
export const updateNewRequestOtherDestinationsLocation = (data) => ({
  type: newRequestTypes.UPDATE_OTHER_DESTINATIONS_LOCATION,
  payload: data,
});

export const fetchNewRequestCitiesStart = () => ({
  type: newRequestTypes.FETCH_CITIES_START,
});
export const fetchNewRequestCitiesSuccess = (cities) => ({
  type: newRequestTypes.FETCH_CITIES_SUCCESS,
  payload: cities,
});

export const setNewRequestSetSelectedProvince = (province) => ({
  type: newRequestTypes.SET_SELECTED_PROVINCE,
  payload: province,
});

export const setNewRequestSetSelectedCity = (city) => ({
  type: newRequestTypes.SET_SELECTED_CITY,
  payload: city,
});

export const setNewRequestSetSelectedDistrict = (district) => ({
  type: newRequestTypes.SET_SELECTED_DISTRICT,
  payload: district,
});

export const setNewRequestSelectionLevel = (level) => ({
  type: newRequestTypes.SET_SELECTION_LEVEL,
  payload: level,
});

export const fetchVehiclesStart = () => ({
  type: newRequestTypes.FETCH_VEHICLES_START,
});

export const fetchVehiclesSuccess = (vehicles) => ({
  type: newRequestTypes.FETCH_VEHICLES_SUCCESS,
  payload: vehicles,
});

export const setSelectedVehicle = (vehicle) => ({
  type: newRequestTypes.SET_SELECTED_VEHICLE,
  payload: vehicle,
});
export const setSelectedVehicleRequested = (vehicle) => ({
  type: newRequestTypes.SET_VEHICLE_REQUESTED_TYPE,
  payload: vehicle,
});
export const setShownSuggestionPrice = (price) => ({
  type: newRequestTypes.SET_SHOWN_SUGGESTIONPRICE,
  payload: price,
});
export const fetchSuggestionPriceStart = () => ({
  type: newRequestTypes.FETCH_SUGGESTIONPRICE_START,
});

export const fetchSuggestionPriceSuccess = (suggestion) => ({
  type: newRequestTypes.FETCH_SUGGESTIONPRICE_SUCCESS,
  payload: suggestion,
});

export const fetchLoadTypesStart = () => ({
  type: newRequestTypes.FETCH_LOADTYPES_START,
});

export const fetchLoadTypesSuccess = (loadTypes) => ({
  type: newRequestTypes.FETCH_LOADTYPES_SUCCESS,
  payload: loadTypes,
});

export const setBimeh = (bool) => ({
  type: newRequestTypes.SET_BIMEH,
  payload: bool,
});

export const setBarnameh = (bool) => ({
  type: newRequestTypes.SET_BARNAMEH,
  payload: bool,
});

export const setLoadValue = (value) => ({
  type: newRequestTypes.SET_LOADVALEU,
  payload: value,
});

export const setLoadDescTakhlie = (desc) => {
  // debugger;
  return {
    type: newRequestTypes.SET_DESC_TAKHLIEH,
    payload: desc,
  };
};

export const setLoadDescBargiry = (desc) => ({
  type: newRequestTypes.SET_DESC_BARGIRY,
  payload: desc,
});

export const setLoadWeight = (weight) => ({
  type: newRequestTypes.SET_LOAD_WEIGHT,
  payload: weight,
});

export const setSizeLength = (length) => ({
  type: newRequestTypes.SET_SIZE_LENGTH,
  payload: length,
});

export const setSizeWidth = (width) => ({
  type: newRequestTypes.SET_SIZE_WIDTH,
  payload: width,
});

export const setSizeHeight = (height) => ({
  type: newRequestTypes.SET_SIZE_HEIGHT,
  payload: height,
});

export const setCalenderBargiryShow = (bool) => ({
  type: newRequestTypes.SET_CALENDERBARGIRY_SHOW,
  payload: bool,
});

export const setCalenderTakhliehShow = (bool) => ({
  type: newRequestTypes.SET_CALENDERTAKHLIEH_SHOW,
  payload: bool,
});

export const fetchDaysAheadStart = () => ({
  type: newRequestTypes.FETCH_DAYSAHEAD_START,
});

export const fetchDaysAheadSuccess = (days) => ({
  type: newRequestTypes.FETCH_DAYSAHEAD_SUCCESS,
  payload: days,
});

export const setBargiryDate = (date) => (dispatch, getState) => {
  if (getState().newReuqest.request_type !== 1) {
    // alert("ok");
  }
  dispatch({
    type: newRequestTypes.SET_BARGIRY_DATE,
    payload: date,
  });
};
export const setBargiryTime = (time) => ({
  type: newRequestTypes.SET_BARGIRY_TIME,
  payload: time,
});

export const setTakhliehDate = (date) => ({
  type: newRequestTypes.SET_TAKHLIEH_DATE,
  payload: date,
});
export const setTakhliehTime = (time) => ({
  type: newRequestTypes.SET_TAKHLIEH_TIME,
  payload: time,
});

export const fetchAuctionStart = () => ({
  type: newRequestTypes.FETCH_AUCTIONLIST_START,
});
export const fetchAuctionSuccess = (auctions) => ({
  type: newRequestTypes.FETCH_AUCTIONLIST_SUCCESS,
  payload: auctions,
});

export const setAuction = (auction) => ({
  type: newRequestTypes.SET_AUCTION,
  payload: auction,
});
export const setAuctionList = (auction) => ({
  type: newRequestTypes.FETCH_AUCTIONLIST,
  payload: auction,
});

export const setLoadDescLoad = (desc) => ({
  type: newRequestTypes.SET_DESC_LOAD,
  payload: desc,
});

export const setSelectedLoadType = (type) => ({
  type: newRequestTypes.SET_LOAD_TYPE,
  payload: type,
});

export const setTakhliehTimeTo = (time) => ({
  type: newRequestTypes.SET_TAKHLIEH_TIMETO,
  payload: time,
});

export const setTakhliehTimeShow = (bool) => ({
  type: newRequestTypes.SET_TAKHLIEH_TIME_SHOW,
  payload: bool,
});
export const setIsTwoWay = () => ({
  type: newRequestTypes.SET_PREREQ_IS_TWO_WAY,
});
export const setPaymentInDestination = () => ({
  type: newRequestTypes.PAYMENT_IN_DESTINATION,
});
export const setVehicleType = (type) => ({
  type: newRequestTypes.SET_VEHICLE_TYPE,
  payload: type,
});
export const setReceiverInfo = (data) => ({
  type: newRequestTypes.SET_RECEIVER_INFO,
  payload: data,
});
export const setLoadingDescription = (data) => ({
  type: newRequestTypes.SET_LOADING_DESCRIPTION,
  payload: data,
});
export const setEvacuationDescription = (data) => ({
  type: newRequestTypes.SET_EVACUATION_DESCRIPTION,
  payload: data,
});
export const setPackagingType = (data) => ({
  type: newRequestTypes.SET_PACKAGING_TYPE,
  payload: data,
});
export const setPostalCode = (data) => ({
  type: newRequestTypes.SET_POSTAL_CODE,
  payload: data,
});
export const setAlertNotifShow = (bool) => ({
  type: newRequestTypes.SET_ALERT_NOTIF_SHOW,
  payload: bool,
});
// async
let fetchNewRequestCitiesAsync_counter = 0;
export const fetchNewRequestCitiesAsync = (socket) => (dispatch) => {
  dispatch(fetchNewRequestCitiesStart());

  socket.emit("get_cities", {});

  if (fetchNewRequestCitiesAsync_counter++ !== 0) return;
  socket.on("response_cities", (data) => {
    // FETCH_DATA.all_cities = data;
    // debugger;
    // console.log(FETCH_DATA.all_cities)
    // addCity();
    dispatch(fetchNewRequestCitiesSuccess(data));
  });
};

let fetchNewRequestVehiclesAsync_counter = 0;
export const fetchNewRequestVehiclesAsync =
  (socket) => (dispatch, getState) => {
    dispatch(fetchVehiclesStart());
    const REQUEST_VEHICLE_DATA = {
      source_location: getState().newReuqest.source_location,
      destination_location: getState().newReuqest.destination_location,
    };
    console.log("bolbol", REQUEST_VEHICLE_DATA);
    socket.emit("get_vehicle_types", {});

    if (fetchNewRequestVehiclesAsync_counter++ !== 0) return;
    socket.on("response_vehicle_types", (data) => {
      console.log("bbb", data);
      // FETCH_DATA.all_cities = data;
      // console.log(FETCH_DATA.all_cities)
      // addCity();
      dispatch(fetchVehiclesSuccess(data));
    });
  };
let fetchSuggestionPriceAsync_counter = 0;
export const fetchSuggestionPriceAsync = (socket) => (dispatch, getState) => {
  dispatch(fetchSuggestionPriceStart());

  const LOAD_TARIFF = {
    vehicle_requested: getState().newReuqest.selected_vehicle,
    source_location: getState().newReuqest.source_location,
    destination_location: getState().newReuqest.destination_location,

    // weight: "",
    // weight_unit: "",
  };
  // debugger;

  socket.emit("get_tariff", LOAD_TARIFF);

  if (fetchSuggestionPriceAsync_counter++ !== 0) return;
  socket.on("response_tariff", (data) => {
    console.log(data);
    // STATE.suggested_price = data;
    // updateSuggestedPrice();
    dispatch(fetchSuggestionPriceSuccess(data));
  });
};

let fetchLoadTypesAsync_counter = 0;
export const fetchLoadTypesAsync = (socket) => (dispatch) => {
  dispatch(fetchLoadTypesStart());

  socket.emit("get_load_types", {});

  if (fetchLoadTypesAsync_counter++ !== 0) return;

  socket.on("response_load_types", (data) => {
    // FETCH_DATA.load_types = data;
    // console.log(FETCH_DATA.load_types)
    // loadTypes()
    dispatch(fetchLoadTypesSuccess(data));
  });
};

let fetchDaysAheadAsync_counter = 0;
export const fetchDaysAheadAsync = (socket) => (dispatch) => {
  dispatch(fetchDaysAheadStart());

  socket.emit("get_days_ahead", {});

  if (fetchDaysAheadAsync_counter++ !== 0) return;

  socket.on("response_days_ahead", (data) => {
    dispatch(fetchDaysAheadSuccess(data));
  });
};

let fetchAuctionAsync_counter = 0;
export const fetchAuctionAsync = (socket) => (dispatch, getState) => {
  dispatch(fetchAuctionStart());
  if (!getState().newReuqest.bargiry_date) return;
  var today = new Date();
  today.setHours(today.getHours() + 1);
  const obj = {
    loading_time: today,
    loading_date: getState().newReuqest.bargiry_date.value,
  };
  // debugger;
  console.log("auction_timelimit", obj);
  socket.emit("get_auction_limits_based_on_loadingtime", obj);

  if (fetchAuctionAsync_counter++ !== 0) return;
  socket.on("response_auction_timelimits", (data) => {
    console.log("auction_timelimit", data);
    dispatch(setAuctionList(data));
    dispatch(fetchAuctionSuccess(data));
  });
};
